<template>
  <v-card flat>
    <v-toolbar flat dense color="theme_primary" class="white--text">
      <v-spacer></v-spacer>
      <v-toolbar-title class="white-text">New offer</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-side-icon>
        <v-icon @click="closeParentDialog()" color="white">close</v-icon>
      </v-toolbar-side-icon>
    </v-toolbar>
    <v-card-text>
      <v-stepper v-model="activeStep" vertical>
        <!-- Supplier -->
        <v-stepper-step
          :editable="activeStep > 1"
          edit-icon="check"
          :complete="activeStep > 1"
          step="1"
        >
          Select a supplier
          <small v-if="newOffer.company_id">{{
            getSupplierName(newOffer.company_id)
          }}</small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-autocomplete
            dense
            :items="productsSupplierCompanies"
            item-value="id"
            item-text="name"
            v-model="newOffer.company_id"
            @input="selectedSupplier"
            background-color="white"
            label="Supplier"
            prepend-icon="store"
          ></v-autocomplete>
          <!-- <v-btn @click="debugSkip">SKIP DEBUG</v-btn> -->
        </v-stepper-content>

        <!-- Payment Settings -->
        <v-stepper-step
          :editable="activeStep > 2"
          edit-icon="check"
          :complete="activeStep > 2"
          step="2"
        >
          Payment Settings
          <small v-if="getPaymentSettings()">{{ getPaymentSettings() }}</small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-autocomplete
            dense
            :items="incoterms"
            item-value="id"
            item-text="name"
            v-model="newOffer.incoterm_id"
            background-color="white"
            label="Incoterm"
            prepend-icon="event_note"
          ></v-autocomplete>
          <v-autocomplete
            dense
            :items="currencies"
            item-value="id"
            item-text="name"
            v-model="newOffer.currency_id"
            background-color="white"
            label="Currency"
            prepend-icon="attach_money"
          ></v-autocomplete>
          <v-btn
            :disabled="!newOffer.currency_id || !newOffer.incoterm_id"
            small
            color="primary"
            depressed
            @click="activeStep = 3"
            >Continue</v-btn
          >
        </v-stepper-content>

        <!-- Port -->
        <v-stepper-step
          :editable="activeStep > 3"
          edit-icon="check"
          :complete="activeStep > 3"
          step="3"
        >
          Select a Port
          <small v-if="newOffer.port_id">{{ getPortName() }}</small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-autocomplete
            dense
            :items="ports"
            item-value="id"
            item-text="name"
            v-model="newOffer.port_id"
            background-color="white"
            clearable
            label="Port"
            prepend-icon="directions_boat"
          ></v-autocomplete>

          <v-autocomplete
            dense
            :items="countries"
            item-value="id"
            item-text="name"
            v-model="newOffer.country_id"
            background-color="white"
            clearable
            autocomplete="noautocomplete"
            label="Origin country"
            prepend-icon="flag"
          ></v-autocomplete>

          <v-btn
            :disabled="!newOffer.port_id"
            depressed
            small
            color="primary"
            @click="activeStep = 4"
            >Continue</v-btn
          >
        </v-stepper-content>

        <!-- Add Product -->
        <v-stepper-step edit-icon="check" :complete="activeStep > 4" step="4"
          >Add a Product</v-stepper-step
        >

        <v-stepper-content step="4">
          <v-autocomplete
            dense
            :disabled="!newOffer.company_id"
            :items="products"
            item-value="id"
            item-text="name"
            v-model="productPackagings[productPackagings.length - 1].product_id"
            background-color="white"
            label="Product"
            prepend-icon="shopping_cart"
          ></v-autocomplete>

          <v-autocomplete
            dense
            :disabled="
              !newOffer.company_id ||
              !productPackagings[productPackagings.length - 1].product_id
            "
            :items="
              fetchPackagings(
                productPackagings[productPackagings.length - 1].product_id
              )
            "
            item-value="id"
            item-text="name"
            v-model="
              productPackagings[productPackagings.length - 1].packaging_ids
            "
            background-color="white"
            multiple
            label="Packaging(s)"
            prepend-icon="mdi-package-variant"
          ></v-autocomplete>

          <v-text-field
            :disabled="
              !newOffer.company_id ||
              !productPackagings[productPackagings.length - 1].product_id
            "
            type="number"
            label="Total Weight ( mt )"
            v-model="productPackagings[productPackagings.length - 1].weight_mt"
            background-color="white"
            required
            prepend-icon="mdi-scale-balance"
          />

          <v-text-field
            :disabled="
              !newOffer.company_id ||
              !productPackagings[productPackagings.length - 1].product_id ||
              !newOffer.currency_id
            "
            :error="!newOffer.currency_id"
            type="number"
            :label="
              'Price ( ' + getObjName(currencies, newOffer.currency_id) + '  )'
            "
            v-model="productPackagings[productPackagings.length - 1].price"
            background-color="white"
            required
            prepend-icon="attach_money"
          />

          <v-btn
            :disabled="
              !newOffer.company_id ||
              !productPackagings[productPackagings.length - 1].product_id ||
              !productPackagings[productPackagings.length - 1].price ||
              !productPackagings[productPackagings.length - 1].weight_mt
            "
            color="primary"
            small
            depressed
            @click="activeStep = 5"
            >Continue</v-btn
          >
        </v-stepper-content>
        <!-- Validation -->
        <v-stepper-step
          :editable="productPackagings.length > 1"
          edit-icon="check"
          :complete="activeStep > 5"
          step="5"
          >Validation</v-stepper-step
        >

        <v-stepper-content step="5">
          <v-card v-if="newOffer.company_id" class="elevation-4">
            <v-toolbar flat color="theme_primary_lighten1" height="36" dark>
              <v-icon small class="pr-2">flight_takeoff</v-icon>
              <span class="subheadings">New Offer Preview</span>
            </v-toolbar>
            <v-card-title class="pb-0">
              <span>
                <v-icon small class="pr-2" color="primary">store</v-icon>
                <span>Supplier:</span>
                <span class="grey--text pl-2">{{
                  getSupplierName(newOffer.company_id)
                }}</span>
                <br />
                <v-icon small class="pr-2" color="primary">event_note</v-icon>
                <span>Incoterm:</span>
                <span class="grey--text pl-2">{{
                  newOffer.incoterm_id
                    ? getObjName(incoterms, newOffer.incoterm_id)
                    : "No."
                }}</span>
                <br />
                <v-icon small class="pr-2" color="primary">attach_money</v-icon>
                <span>Currency:</span>
                <span class="grey--text pl-2">{{
                  newOffer.currency_id
                    ? getObjName(currencies, newOffer.currency_id)
                    : "No."
                }}</span>
                <br />
                <v-icon small class="pr-2" color="primary"
                  >directions_boat</v-icon
                >
                <span>Port:</span>
                <span class="grey--text pl-2">{{
                  getObjName(ports, newOffer.port_id)
                }}</span>
              </span>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-subheader>
                Product(s)
                <v-spacer></v-spacer>
                <v-tooltip left>
                  <div slot="activator">
                    <v-btn
                      icon
                      small
                      color="primary"
                      depressed
                      @click="addProductPackagings"
                    >
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </div>
                  <span>Add a new product to the offer</span>
                </v-tooltip>
              </v-subheader>
              <v-flex class="pb-4">
                <v-expansion-panel light class="mini">
                  <template v-for="(pp, index) in productPackagings">
                    <v-expansion-panel-content
                      v-if="pp.product_id"
                      :key="pp.id"
                    >
                      <template v-slot:header>
                        <v-flex xs8>
                          <span>
                            <v-icon small color="grey lighten1"
                              >shopping_cart</v-icon
                            >
                            {{
                              truncateBreakpoint(
                                getObjName(products, pp.product_id)
                              )
                            }}
                          </span>
                        </v-flex>

                        <v-flex xs2>
                          <span>
                            <v-icon color="grey lighten1" small
                              >attach_money</v-icon
                            >
                            {{
                              pp.price +
                              getObjName(currencies, newOffer.currency_id)
                            }}
                          </span>
                        </v-flex>

                        <v-flex xs2>
                          <span>
                            <v-icon color="grey lighten1" small
                              >mdi-scale-balance</v-icon
                            >
                            {{ pp.weight_mt + "mt" }}
                          </span>
                        </v-flex>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-container grid-list-md text-xs-center class="pa-0">
                            <v-layout row wrap>
                              <v-flex
                                xs3
                                md3
                                v-for="pck in pp.packaging_ids"
                                :key="pck"
                                justify-center
                              >
                                <div class="text-xs-center">
                                  <v-flex xs12>
                                    <v-icon
                                      style="-webkit-text-stroke: 2px white;"
                                      color="grey lighten-"
                                      size="44"
                                      >mdi-package-variant</v-icon
                                    >
                                  </v-flex>
                                  <v-flex xs12>
                                    <span>{{ getPackagingName(pck) }}</span>
                                  </v-flex>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            small
                            flat
                            color="error"
                            depressed
                            @click="removeProduct(index)"
                          >
                            Remove product from offer
                            <v-icon small class="pl-2">delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-expansion-panel-content>
                  </template>
                </v-expansion-panel>
              </v-flex>
              <v-autocomplete
                dense
                :items="shipments"
                item-value="id"
                item-text="name"
                v-model="newOffer.shipment_id"
                background-color="white"
                label="Shipment"
                :prepend-icon="
                  newOffer.shipment_id
                    ? shipments.find((s) => s.id == newOffer.shipment_id).icon
                      ? shipments.find((s) => s.id == newOffer.shipment_id).icon
                      : 'view_quilt'
                    : 'view_quilt'
                "
              ></v-autocomplete>

              <v-text-field
                type="number"
                :label="
                  'Number of Shipping Units' +
                  (newOffer.shipment_id
                    ? ' (' +
                      shipments.find((s) => s.id == newOffer.shipment_id).name +
                      ')'
                    : '')
                "
                v-model="newOffer.shipping_quantity"
                background-color="white"
                :disabled="!newOffer.shipment_id"
                required
                :prepend-icon="
                  newOffer.shipment_id
                    ? shipments.find((s) => s.id == newOffer.shipment_id).icon
                      ? shipments.find((s) => s.id == newOffer.shipment_id).icon
                      : 'view_quilt'
                    : 'view_quilt'
                "
              />
            </v-card-text>
          </v-card>
        </v-stepper-content>
      </v-stepper>
    </v-card-text>
    <v-card-actions>
      <v-btn
        depressed
        :disabled="!(activeStep == 5)"
        block
        color="success"
        @click="createOfferDemand"
      >
        <v-icon class="pr-2" small>save</v-icon>Save new offer
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import CREATE_OFFER from "../../graphql/offers/create.gql";
import CREATE_DEMAND from "../../graphql/demands/create.gql";
import COMPANY_SHOW_PRODUCTS from "../../graphql/companies/show_products.gql";
export default {
  data() {
    return {
      activeStep: 1,
      products: [],
      ports: [],
      commercialProducts: [],
      incoterms: [],
      currencies: [],
      countries: [],
      productPackagings: [
        { product_id: "", packaging_ids: [], weight_mt: null, price: null },
      ],
      newOffer: {
        name: "",
        incoterm_id: "",
        company_id: "",
        port_id: "",
        currency_id: "",
      },
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "productsSupplierCompanies",
      "customers",
      "packagings",
      "shipments",
    ]),
  },
  methods: {
    debugSkip() {
      this.newOffer.company_id = this.productsSupplierCompanies[0].id;
      this.selectedSupplier(this.newOffer.company_id);
      this.newOffer.port_id = this.ports[0].id;
      this.newOffer.currency_id = this.currencies[0].id;
      this.newOffer.incoterm_id = this.incoterms[0].id;
      this.productPackagings = [
        {
          product_id: this.products[0].id,
          packaging_ids: [],
          weight_mt: 452,
          price: 321,
        },
      ];
      this.activeStep = 5;
    },
    removeProduct(index) {
      if (this.productPackagings.length > 1)
        this.productPackagings.splice(index, 1);
      else {
        this.productPackagings[0].product_id = "";
        this.productPackagings[0].packaging_ids = [];
        this.productPackagings[0].weight_mt = null;
        this.productPackagings[0].price = null;
        this.activeStep = 4;
      }
    },
    getPackagingName(pck) {
      return this.packagings.find((p) => p.id == pck).name;
    },
    addProductPackagings() {
      this.productPackagings = this.productPackagings.concat({
        product_id: "",
        packaging_ids: [],
        weight_mt: null,
        price: null,
      });
      this.activeStep = 4;
    },
    truncateBreakpoint(input) {
      if (this.$vuetify.breakpoint.xs && input.length > 25)
        return input.substring(0, 25) + "...";

      if (this.$vuetify.breakpoint.sm && input.length > 40)
        return input.substring(0, 40) + "...";

      return input.substring(0, 80) + "...";
    },
    getPackagingNames(product) {
      if (product && product.packaging_ids.length > 0)
        return product.packaging_ids
          .map((id) => this.packagings.find((p) => p.id == id).name)
          .join(", ");
      else return "No packagings";
    },
    fetchPackagings(id) {
      return this.commercialProducts
        .filter((e) => e.product.id == id)
        .map((e) => e.packagings)
        .flat();
    },
    getSupplierName(id) {
      var res = this.productsSupplierCompanies.filter((o) => {
        if (o.id === id) return o;
      });
      return res[0].name;
    },
    getObjName(obj, id) {
      if (obj == undefined || id == undefined || id == "") return "";
      var res = obj.filter((o) => {
        if (o.id === id) return o;
      });

      return res[0].name;
    },
    getPaymentSettings() {
      var str = "";
      str += this.newOffer.incoterm_id
        ? "Incoterm: " +
          this.getObjName(this.incoterms, this.newOffer.incoterm_id) +
          " "
        : "No incoterm.";
      str += this.newOffer.currency_id
        ? "Currency: " +
          this.getObjName(this.currencies, this.newOffer.currency_id)
        : "No currency";
      return !this.newOffer.incoterm_id && !this.newOffer.currency_id
        ? ""
        : str;
    },
    getPortName() {
      var str = "";
      str += this.newOffer.port_id
        ? "Port: " + this.getObjName(this.ports, this.newOffer.port_id) + " "
        : "No port.";
      return !this.newOffer.port_id ? "" : str;
    },
    closeParentDialog() {
      this.$emit("closeDialog", false);
    },
    resetNewOffer() {
      this.newOffer = {
        name: "",
        incoterm_id: "",
        company_id: "",
        port_id: "",
        currency_id: "",
        shipment_id: "",
        shipping_quantity: 0,
      };
      this.activeStep = 1;
    },
    createOfferDemand() {
      this.newOffer.shipping_quantity = parseInt(
        this.newOffer.shipping_quantity
      );
      this.productPackagings.forEach((e) => {
        // for offer:
        e.weight_mt = parseFloat(e.weight_mt);
        e.price = parseFloat(e.price);
        // for demand it will be:
        // delete e.weight_mt;
        // delete e.price;
      });
      const variables = {
        ...this.newOffer,
        product_packagings_entities: this.productPackagings,
      };

      this.sendMutation("created", "offer", CREATE_OFFER, variables).then(
        () => {
          this.resetNewOffer();
          this.closeParentDialog();
        }
      );
    },
    selectedSupplier(id) {
      this.productPackagings = [
        { product_id: "", packaging_ids: [], weight_mt: null, price: null },
      ];

      this.newOffer.port_id = "";
      this.newOffer.incoterm_id = "";
      this.newOffer.currency_id = "";

      this.sendQuery(COMPANY_SHOW_PRODUCTS, { id }).then((data) => {
        this.commercialProducts = data.company.company_contacts
          .map((c) => c.commercial_zones)
          .flat()
          .map((c) => c.commercial_products)
          .flat();

        this.ports = data.company.supplier.ports;
        this.countries = data.company.supplier.countries;
        this.incoterms = data.company.supplier.incoterms;
        this.currencies = data.company.supplier.currencies;

        this.products = this.commercialProducts.map((e) => e.product);
      });
      this.activeStep = 2;
    },
  },
};
</script>
<style lang="stylus">
.mini {
  .v-expansion-panel__container--active > .v-expansion-panel__header {
    background-color: #f1f1f1 !important;
    color: black !important;
  }

  .v-expansion-panel__header {
    min-height: 0;
    padding: 3px 24px !important;
  }

  tbody {
    tr {
      height: 60px !important;

      td {
        height: 20px !important;
      }
    }
  }
}
</style>
